import React from 'react';
/**
 * Backwards-compatible re-export of the shared `MasteryBar` component.
 *
 * Per ADMIN_DOMAIN_RC_AUDIT_2026 §19.4 P1-4 the admin-local fork (drempels
 * 80/60/40, kleuren emerald/amber/orange/red) is removed in favour of the
 * canonical `portals/shared/MasteryBar.tsx` which reads from
 * `masteryBands.ts` (drempels 75/55/35, kleuren emerald/indigo/amber/rose).
 *
 * Existing admin callers (`SupportContentPage`, `users/columns`,
 * `users/SchoolDetailPanel`) keep their imports unchanged.
 */
export { MasteryBar } from '../../shared/MasteryBar';